import { Component , Prop , Mixins} from 'vue-property-decorator';
import { required, maxLength, decimal, between } from 'vuelidate/lib/validators'
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import { Section } from '@/courses/models/section.model';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import  KEYS  from '@/values/keys';
import { SECTION_TYPES } from '@/content/values/sections';
import { SectionsProvider } from '@/content/providers/sections.provider';
import EdImageCreated from './components/ed-image-created/ed-image-created.vue';
import { RequestProvider } from '@/shared/providers/request.provider';
import { SERVER_HOSTNAME } from '@/shared/enums/request.enum';

@Component({name: 'ed-lesson-create-image',
  components: {
    EdImageCreated,
    EdSelectTag: () => import(/* EdSelectTag */'@/courses/components/ed-select-tag/ed-select-tag.component.vue')
  }
})
export default class EdLessonCreateImage extends Mixins(CreateObjectsMixin) {

  /* Props */
  // @Prop() readonly params: any; //Typescript upgrade
  declare readonly params: any;
  

  /* Data */
  private section: Section = null;
  private sectionId: number = null;
  private requestDataForm: any = {}
  private filesTosend: Array<any> = [];
  private imagesListPreview: Array<any> = [];
  public deleteImages: Array<string> = []
  public dropzoneMode: string = KEYS.DROPZONE_CONFIG.MULTIPLE;
  public firstRequest: boolean = false;
  public isSaving: boolean = false;
  public numberFilesToSend: number = null;
  public form: any = {}
  public dropOptions: any = {};
  public tags: Array<string> = ['TEST', 'CLASSWORK', 'HOMEWORK'];
  public tagSelected: string = '';

  /* Computed */
  get imagesList(): any[] {
    return this.imagesListPreview.map( (data, index) => {
      return {
        hash: data.hash ? data.hash : index,
        thumbnailMediumUrl: URL.createObjectURL(data.file),
        file: data.file
      }
    });
  }

  get filesToSendLenth(): boolean {
    return this.filesTosend.length > 0;
  }

  get edition(): boolean {
    if(this.isFeedBack) return false
    else return this.params.objId !== null;
  }

  get countFilesToSend(): number {
    return this.numberFilesToSend === this.filesTosend.length ? 1 :
    this.numberFilesToSend  - this.filesTosend.length ;
  }

  get title(): string {
    if(this.isFeedBack) {
      return this.params.titleModal;
    }
    return this.edition ? String(this.$i18n.t('lesson.editImageTitle')) : 
    String(this.$i18n.t('courses.objects.createImage'));
  }

  get isFeedBack(): boolean {
    return 'section' in this.params;
  }

  get showElementInFeedBack(): boolean {
    if(this.isFeedBack) {
      this.dropOptions = this.params.dropOptions;
      this.dropOptions.autoQueue = false;
      return this.filesTosend.length < 1;
    } else return true;
  }

  get showDropzone(): boolean {
    return !this.isSaving && this.showElementInFeedBack && 
    this.imagesList.length < this.dropOptions.maxFiles;
  }

  get courseType(): string {
    return this.$store.state.CourseStore.courses.content.find(
      (course: any) => course.id === this.params.courseId
    )?.type;
  }

  get showDisclaimer(): boolean {
    return this.deleteImages.length > 0 && ![KEYS.CONTENT_TYPE.COURSE_TEMPLATE, KEYS.CONTENT_TYPE.CST].includes(this.courseType);
  }

  /* Methods */
  private initForm(name: string = '') {
    this.form = EdFormModel([
      EdInputModel('name', name, {required, maxLength: maxLength(60)}),
      EdInputModel('grade', '', { decimal, between: between(0, 100)})
    ]);
    if(!this.hasGradeField) {
      this.form.setValid('grade', true);
    }
  }

  private async setImageOnEdition(imagesList: Array<any>) {
    for (let index = 0; index < imagesList.length; index++) {
      let request = await fetch(imagesList[index].url);
      let blob: Blob = await request.blob();    
      let image: File = new File([blob] , imagesList[index].fileName);
      this.imagesListPreview.push({file : image , hash: imagesList[index].hash });
    }
  }

  private setDataToSave() {
    let base: any = {
      name: this.form.name.value,
      description: '',
      type:  SECTION_TYPES.LESSON_IMAGES.code,
      grade: this.form.grade.value,
      component: this.componentSelected
    };
    
    if (this.tagSelected) {
      base.labelSections = this.tagSelected
    }

    if(!this.params.formatData) {
      let nameParam = 'requestDataName' in this.params ?  this.params.requestDataName : 'homework';
      this.requestDataForm[nameParam] = base;
      if(('section' in this.params) && ('isResponse' in this.params.section)) {
        this.requestDataForm.isResponse = this.params.section.isResponse;
      }
    } else {
      this.requestDataForm = this.params.formatData(base);
    }
  }

  public onFileAdd(file: File) {
    let data = {
      file: file,
      hash: null
    }
    if(this.imagesListPreview.length < 5) {
      this.imagesListPreview.push(data);
      this.filesTosend.push(data);
    } else {
      this.showMaxFilesErroModal();
    }
  }

  public saveImages(firstRequest: boolean = false) {
    this.firstRequest = firstRequest;
    this.firstRequest ? this.numberFilesToSend = this.filesTosend.length : null;
    this.isSaving = true;
    if(this.edition) {
      this.saveEditionImages(firstRequest);
    } else {
      (this.$refs.dropzoneRef as any).enqueueFile({file: this.filesTosend[0].file,
      url: this.dropOptions.url});
      if(this.firstRequest) {
        this.setDataToSave(); 
        (this.$refs.dropzoneRef as any).processQueue(this.requestDataForm)        
      } else (this.$refs.dropzoneRef as any).processQueue();
    }
  }

  private async saveEditionImages(firstRequest: boolean = false) {
    this.firstRequest = firstRequest;
    try {
      if(this.firstRequest) {
        let data = this.section;
        data.name = this.form.name.value;
        data.description = '';
        data.labelSections = this.tagSelected;
        data.component = this.componentSelected;
        // Archive transparency boards only if images are deleted
        data.archiveCurrentHomeworks = this.deleteImages.length > 0;
        await this.editObject(data);
      }    
      if(this.deleteImages.length > 0) {
        let imageInfo = {section: this.section , hash: null}      
        for(const hash of this.deleteImages){
          imageInfo.hash = hash;
          await this.$Courses.Store.removeImgFromSectionA(imageInfo);
        }
        this.deleteImages = [];     
      }    
      if(this.filesToSendLenth) {
        (this.$refs.dropzoneRef as any).enqueueFile({file: this.filesTosend[0].file, url: null});
        (this.$refs.dropzoneRef as any).processQueue();
      } else {
        setTimeout(() => {
          this.goToRefreshSectionsTree(this.setRefreshData());
          this.closeModal();
        }, 500)
      }
    } catch(err) {
      this.showErroModal();
      this.isSaving = false;
    }
  }

  public async onImageUploadedSuccess({file, res}) {
    if(this.firstRequest) {
      this.dropOptions.url = `${process.env[SERVER_HOSTNAME.COMMON]}/content/upload/${this.params.courseId}/structure/${res.id}`
      this.edition ? null : this.sectionId = res.id;
    }      
    this.filesTosend.shift();
    if(this.filesToSendLenth) {
      this.edition ? this.saveEditionImages() : this.saveImages();
    } else if(this.isFeedBack) {
      this.$edEventBus.$emit(this.params.modalBusSaveEvent, this.requestDataForm , this.params);
      await this.refreshSelectedStudentWidget();
      this.closeModal();
    } else {
      await this.goToRefreshSectionsTree(this.setRefreshData());
      this.closeModal();
    }       
  }

  private setRefreshData(): any  {
    let data = {sectionId: this.sectionId , parentId: this.params.parentId ,
    courseId: this.params.courseId , classId: this.params.classId};
    return data;
  }

  public removeImg(data: any) {
    let indexPreview = this.imagesListPreview.findIndex((image, i) => image.hash ? image.hash === data.hash : i === data.hash);
    this.imagesListPreview.splice(indexPreview , 1);
    if (typeof data.hash == 'string') {
      this.deleteImages.push(data.hash);      
    } else {
      let indexFiles: number = this.filesTosend.findIndex((image: any, i) => {
        if (image.hash) return image.hash === data.hash
        else return i === data.hash
      });
      this.filesTosend.splice(indexFiles, 1);
      (this.$refs.dropzoneRef as any).removeFile(data.file);
    }

  }

  public closeModal() {
    this.$EdModal.closeModal();
  }

  public showErroModal() {
    this.$EdModal.createMessageModal({
      title: this.title,
      body: this.$i18n.t('courses.errors.errorSavingObject'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  public showMaxFilesErroModal() {
    this.$EdModal.createMessageModal({
      title: this.title,
      body: this.$i18n.t('courses.errors.errorMaxFiles'),
      type: KEYS.EVENT_TYPES.WARNING
    });
  }

  public onErrorMaxFiles(err) {
    this.showMaxFilesErroModal();
    this.imagesListPreview.splice(5);
    this.filesTosend.splice(5);
  }

  public onError(err) {
    if(err?.file?.status !== 'canceled')
      this.showErroModal();
  }

  public setDropOptions(path: string) {
    this.dropOptions = {
      url: `${process.env[SERVER_HOSTNAME.COMMON]}/${path}`,
      autoProcessQueue: false,
      autoQueue: false,
      paramName:'file',
      acceptedFiles: 'image/png,.jpg,.jpeg',
      uploadMultiple: false,
      parallelUploads: 1,
      maxFiles: 5,
      createImageThumbnails: false,
      timeout: 600000,
      headers: RequestProvider.getTokenHeader()
    }
  }

  /* Hooks */
  created() {
    this.setDropOptions(this.params.dropOptions.url);
    if(this.edition) {
      this.section = SectionsProvider.getSectionById(this.course.sections, this.params.objId).value;
      this.section.assetsInfo = this.section.assetsInfo ? this.section.assetsInfo : [];
      this.initForm(this.section.name);
      this.setImageOnEdition(this.section.assetsInfo);
      this.sectionId = this.section.sectionId;
      this.tagSelected = this.section.labelSections;
      if(this.section.component) {
        this.componentSelected = this.components.find(c => c.id == this.section.component.id);
      } else if(this.components) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    } else {
      this.initForm();
      if(this.course.eduacComponents) {
        this.componentSelected = this.components.find(c => c.mandatory);
      }
    }
  }
}
